export { default } from './AppointmentOutcomes';
